/** Retries while the third-party widget has not rendered its shadow root yet */
const MAX_TRIES = 20;
const RETRY_MS = 300;

/**
 * Inline styles injected into the widget's shadow root. Flex wrappers ignore vertical-align, so the logo is made
 * inline. The wordmark baseline sits at 74% of the SVG height: dropping the SVG by the remaining 26% (x 1.3em) puts
 * it on the text baseline. Gaps become one normal word space.
 */
const SHADOW_CSS =
  '.sp--nowrap{margin-right:0!important}.sp-link,.sp-logo{display:inline!important}' +
  '.sp-logo svg{display:inline-block!important;width:auto!important;height:1.3em!important;vertical-align:-.337em!important}' +
  '.sp-icon{display:inline-block!important;margin-left:.15em!important;vertical-align:middle}.sp-icon svg{display:block;width:.7em;height:.7em}' +
  '.sp-price{font-size:inherit!important;font-weight:500!important}';

/**
 * Wraps a `<scalapay-widget>` and puts its logo in line with the text: the widget's styles live in a
 * shadow root, so a small stylesheet is added there once the widget has rendered (after window load).
 */
class CustomScalapay extends HTMLElement {
  /** @type {ReturnType<typeof setTimeout> | undefined} */
  #timer;

  connectedCallback() {
    if (document.readyState === 'complete') this.#tune();
    else window.addEventListener('load', this.#onLoad, { once: true });
  }

  disconnectedCallback() {
    window.removeEventListener('load', this.#onLoad);
    clearTimeout(this.#timer);
  }

  #onLoad = () => this.#tune();

  /** @param {number} [tries] */
  #tune(tries = 0) {
    const root = this.querySelector('scalapay-widget')?.shadowRoot;
    if (!root || !root.querySelector('.sp-logo')) {
      if (tries < MAX_TRIES) this.#timer = setTimeout(() => this.#tune(tries + 1), RETRY_MS);
      return;
    }
    if (root.querySelector('style[data-cx]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-cx', '');
    style.textContent = SHADOW_CSS;
    root.appendChild(style);
  }
}

if (!customElements.get('custom-scalapay')) {
  customElements.define('custom-scalapay', CustomScalapay);
}
